import {$http, Constants} from '@/store/actions/constants';

const url = `${Constants.BaseURL}/policy/timeoff`;
export const LeavesAction = {
    find: ({commit, state}, search) => {
        return $http.get(url, {...state.authHeader, params: search}).then(r => {
            if (r.status === 200) {
                commit('SET_LEAVE_TYPES', r.data);
            }
        });
    },

    // list of admin leave policies
    search: ({commit, state}) => {
        return $http.get(`${url}/search`, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('SET_ADMIN_LEAVE_TYPES', r.data);
            }
        });
    },

    add: ({commit, state}, data) => {
        return $http.post(url, data, state.authHeader);
    },

    delete: ({commit, state}, id) => {
        return $http.delete(`${url}/${id}`, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('DELETE_LEAVE_TYPES', id);
            }
        });
    },

    edit: ({commit, state}, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader);
    },

    get: ({_, state}, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },
};